import { createHTMLMapMarker } from './html-map-marker'
import ListUtil from '../pricetravel/list/utils';
import { getHeaders } from '../pricetravel/shared/tokenUtil';
import { AMENITIES_DESCRIPTIONS } from '../../utils/pricetravel/shared/cardService'
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default class GoogleMapList {
    constructor(model, http, filter, scope, userKeyFac) {
        this.vm = model;
        this.http = http;
        this.filter = filter;
        this.scope = scope;
        this.fn = window.__pt.fn;
        this.config = window.__pt.settings.site;
        this.resolution = window.__pt.resolution;
        this.box = window.__pt.box;
        this._userKeyFac = userKeyFac;
        this.showServices = this.config.showServices;

        this.map = null;
        this.markers = [];
        this.markerCluster = null;
        this.mapInitialized = false;

        //bandera filtros
        this._lastFiltersKey = null;

        this.safeApply = fn => {
            if (!this.scope.$$phase && !this.scope.$root.$$phase) {
                this.scope.$apply(fn);
            } else {
                fn();
            }
        };
    }

    initialize() {
        this.hotels = [];
        this.itemsHotel = null;
        this.vm.showMapDetail = false;
        this.vm.detailCardMap = {};
        this.vm.loading_refresh_map = null;

        if (this.onRenderMap()) {
            this.getHotels();
        }

        this.clearMarkers();
    }

    openMap(params, paramsRates, paxes, campaignToken, paramsFilter) {
        $(`#modal-mapsearch`).modal("show");
        this.params = params;
        this.paramsRates = paramsRates;
        this.paxes = paxes;
        this.campaignToken = campaignToken;
        this.paramsFilter = paramsFilter;
        this.initialize();
        this._listUtil = new ListUtil(params, this.config, "...");
    }

    async getHotels() {
        this.vm.loading = true;
        let paramsClone = this.fn.clone(this.paramsFilter);
        paramsClone.page = 1;
        paramsClone.profileId = this.vm.paramsFilter.profileId;
        paramsClone.pageSize = this.config.listItemsMapCount;
        paramsClone.filters = this.vm.filtersSelectedArrayString.join(",");
        paramsClone.filtersCustom = this.vm.filterCustomList.map(f => f.uri).join(",");
        let headers = getHeaders();
        
        let response = await this.http.get(this.config.endPoints.filterUrl, { params: paramsClone, headers });
        if (response && response.data && response.data.hotels) {
            this.hotels = response.data.hotels;
            this.vm.pagination.totalHotels = response.data.totalHotels;
            this.vm.onLoadFilters(response.data.filterGroups);
            this.vm.hotelFilters.filterCustoms.filterGroups =
                this._listUtil.setIsSelectCustomFilter(response.data.filterCustoms.filterGroups);
        }

        this.vm.loading = false;
        this.getRates();
    }

    async getRates() {
        this.safeApply(() => { this.vm.no_result_map = true; });
        this.vm.loading_refresh_map = true;

        this.createUrlDetail();
        await this.centerMap();

        this.safeApply(() => { this.vm.loading_refresh_map = false; });
    }

    createUrlDetail() {
        let pax = this.fn.mapPaxToUrl(this.box.pax);
        let base = { checkin: this.box.checkIn, checkout: this.box.checkOut, ...pax };
        if (this.campaignToken) base.CampaignToken = this.campaignToken;
        let query = this.fn.objectToQueryParams(base);

        this.hotels.forEach(h => {
            h.url = `${this.config.siteUrl}${this.config.pathHotelDetail}${h.uri}?${query}`;
        });
    }

    onRenderMap() {
        if ('google' in window && google.maps) {
            return true;
        }
        this.fn.getScript(this.config.endPoints.googleMapsApi, "", () => {
            this.getHotels();
        });
        return false;
    }

    async centerMap() {
        this.itemsHotel = [];
        this.updateHotelTags(this.hotels);

        let points = this.hotels
            .filter(h => h.price)
            .map(h => {
                const lat = parseFloat(h.locationInfo.latitude);
                const lng = parseFloat(h.locationInfo.longitude);
                this.itemsHotel.push({
                    id: h.hotelId,
                    url: h.url,
                    name: h.name,
                    price: h.price,
                    latitude: lat,
                    longitude: lng,
                    cloudUri: h.mainPhoto?.cloudUri && this.resolution?.list?.widthB && this.resolution?.list?.heightB
                        ? `${h.mainPhoto.cloudUri}?tx=w_${this.resolution.list.widthB},h_${this.resolution.list.heightB},g_auto,c_fill`
                        : null,
                    stars: Math.round(h.stars),
                    surveyAverage: h.surveyAverage,
                    highlightedAttributes: h.highlights,
                    showPromotion: h.showPromotion,
                    showHotSBlackFri: h.showHotSBlackFri,
                    taxes: h.taxes,
                    services: h.services
                });
                return { latitude: lat, longitude: lng };
            });

        if (!points.length) {
            console.error('No valid points found for centering the map.');
            return;
        }

        await this.vm.getUSersFavorites();

        if (!this.mapInitialized) {
            
            const calculatePercentile50 = coords => {
                const i = Math.floor(coords.length * 0.5);
                coords.sort((a, b) => a.longitude - b.longitude); let lon = coords[i].longitude;
                coords.sort((a, b) => a.latitude - b.latitude); let lat = coords[i].latitude;
                return { latitude: lat, longitude: lon };
            };
            const center = calculatePercentile50(points);
            this.initializeMap(center.latitude, center.longitude, this.itemsHotel);
            this.mapInitialized = true;
        } else {
            const c = this.map.getCenter();
            this.updateHotelsOnMap(c.lat(), c.lng());
        }

        this.safeApply(() => {
            this.vm.no_result_map = this.itemsHotel.length;
        });
    }


    initializeMap(latMid, lonMid, hotelsMap) {
        const center = { lat: latMid, lng: lonMid };
        this.initializeGoogleMap(center);

        const km = hotelsMap.length <= 1000 ? 5 : hotelsMap.length <= 1500 ? 3 : 1;
        const filtered = hotelsMap.filter(h =>
            this.calculateDistance(h.latitude, h.longitude, center.lat, center.lng) <= km
        );

        setTimeout(() => this.settingCluster(filtered), 0);
    }

    updateHotelsOnMap(lat, lng) {
        if (!this.itemsHotel) return;
        const km = this.itemsHotel.length <= 300 ? 5 : this.itemsHotel.length <= 700 ? 3 : 1;
        const filtered = this.itemsHotel.filter(h =>
            this.calculateDistance(h.latitude, h.longitude, lat, lng) <= km
        );
        setTimeout(() => this.settingCluster(filtered), 0);
    }

    initializeGoogleMap(center = {}, zoom = 12) {
        this.map = new google.maps.Map(
            document.getElementById('map'),
            {
                zoom, center,
                disableDefaultUI: true,
                zoomControl: true,
                gestureHandling: "greedy",
                styles: [{ featureType: "poi.business", stylers: [{ visibility: "off" }] }]
            }
        );
        this.map.addListener("idle", () => {
            const c = this.map.getCenter();

            const currentFiltersKey = this.getFiltersKey();
            if (this._lastFiltersKey !== currentFiltersKey) {
                this._lastFiltersKey = currentFiltersKey;
                this.paramsFilter.lat = c.lat();
                this.paramsFilter.lng = c.lng();
                this.getHotels(); 
            } else {
                this.updateHotelsOnMap(c.lat(), c.lng());
            }            
        });
    }

    calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371;
        const dLat = this.toRad(lat2 - lat1);
        const dLon = this.toRad(lon2 - lon1);
        const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(this.toRad(lat1)) *
            Math.cos(this.toRad(lat2)) *
            Math.sin(dLon / 2) ** 2;
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    toRad(deg) { return deg * Math.PI / 180 }

    clearMarkers() {
        this.markers.forEach(m => m.setMap(null));
        this.markers = [];
    }

    clearBubble() {
        $(".speech-bubble.speech-bubble-active").removeClass('speech-bubble-active');
    }

    getFiltersKey() {
        const selected = this.vm.filtersSelectedArrayString.join(',');
        const custom = this.vm.filterCustomList.map(f => f.uri).join(',');
        return `${selected}|${custom}`;
    }

    updateHotelTags(hotels) {
        hotels.forEach(h => {
            if (!h.services || !Array.isArray(h.services)) return;
            h.services = h.services
                .map(s => this.findReviewByText(s.name))
                .filter(Boolean)
                .sort((a, b) => a.order - b.order)
                .reduce((acc, cur) => { if (!acc.some(x => x.order === cur.order)) acc.push(cur); return acc }, [])
                .slice(0, 3)
                .map(s => { if (s.order === 1) s.text = 'Wi-fi'; return s });
        });
    }

    findReviewByText(text) {
        if (!text) return null;
        const lower = text.toLocaleLowerCase();
        for (let [key, rev] of Object.entries(AMENITIES_DESCRIPTIONS)) {
            const es = rev.es?.toLocaleLowerCase() || '', en = rev.en?.toLocaleLowerCase() || '';
            if (es.includes(lower) || en.includes(lower)) {
                return { key, text: this.config.language === 'es' ? rev.es : rev.en, ...rev };
            }
        }
        return null;
    }

    settingCluster(filteredHotels) {
        if (this.markers.length) {
            this.markers.forEach(m => m.setMap(null));
        }
        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
            this.markerCluster.setMap(null);
            this.markerCluster = null;
        }
        this.markers = filteredHotels.map(h => {
            const latLng = new google.maps.LatLng(h.latitude, h.longitude);
            const marker = createHTMLMapMarker({
                latlng: latLng,
                map: null,
                id: h.id,
                uri: h.uri,
                name: h.name,
                price: h.price,
                discount: h.discount,
                beforePromo: h.beforePromo,
                tax: h.taxPerRoomPerNight,
                cloudUri: h.cloudUri,
                stars: Math.round(h.stars),
                surveyAverage: h.surveyAverage,
                highlightedAttributes: h.highlightedAttributes,
                showPromotion: h.showPromotion,
                showHotSBlackFri: h.showHotSBlackFri,
                url: h.url,
                taxes: h.taxes,
                html: `
          <div id="hotel_bubble_${h.id}" class="speech-bubble">
            ${this.vm.isFavoriteHotel(h.id) ? '<i class="icons-heart"></i>' : ''}
            ${this.vm.renderCurrencyDisplay(h.price, h.id)}
          </div>`
            });

            marker.addListener('click', () => {
                this.clearBubble();
                this.safeApply(() => {
                    this.vm.detailCardMap = {
                        id: marker.id,
                        name: marker.name,
                        stars: marker.stars,
                        cloudUri: h.cloudUri,
                        surveyAverage: marker.surveyAverage,
                        price: marker.price,
                        discount: marker.discount,
                        beforePromo: marker.beforePromo,
                        taxPerRoomPerNight: marker.tax,
                        showPromotion: marker.showPromotion,
                        showHotSBlackFri: marker.showHotSBlackFri,
                        highlights: marker.highlightedAttributes,
                        url: h.url,
                        taxes: h.taxes,
                        isFavorite: this.vm.isFavoriteHotel(marker.id),
                        services: h.services
                    };
                });
                setTimeout(() => {
                    this.safeApply(() => { this.vm.detailCardMap.show = true });
                }, 0);
                setTimeout(() => {
                    const id = `#hotel_bubble_${marker.id}`;
                    $(id).addClass('speech-bubble-active');
                    $('#image-map-card').css('background-image', `url(${h.cloudUri})`);
                }, 100);
            });

            return marker;
        });
        if (this.paramsFilter.profileId) {
            const sel = parseInt(this.paramsFilter.profileId, 10);
            const m = this.markers.find(x => x.id === sel);
            if (m) setTimeout(() => google.maps.event.trigger(m, 'click'), 300);
        }
        this.markerCluster = new MarkerClusterer({
            map: this.map,
            markers: this.markers,
            renderer: {
                render: ({ count, position }) => {
                    const d = 40;
                    const cv = document.createElement('canvas');
                    cv.width = d; cv.height = d;
                    const ctx = cv.getContext('2d');
                    const bg = getComputedStyle(document.documentElement)
                        .getPropertyValue('--marker-cluster-bg').trim();
                    ctx.fillStyle = bg;
                    ctx.beginPath();
                    ctx.arc(d / 2, d / 2, d / 2, 0, 2 * Math.PI);
                    ctx.fill();
                    ctx.fillStyle = 'white';
                    ctx.font = 'bold 16px Arial';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(count.toString(), d / 2, d / 2);
                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: cv.toDataURL(),
                            scaledSize: new google.maps.Size(d, d)
                        }
                    });
                }
            }
        });
    }
}
